(ns ycweb.app.website.dlp.widgets.competition
  (:require
   [ajax.core :as ajax]
   [cemerick.url :as url]
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.dlp.widgets.banner :as banner]
   [ycweb.app.website.dlp.widgets.header :as hd]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn post-competition-form-clj [app-atom component]
  #?(:cljs
     (let [params (cmn/screen-params app-atom)
           {:competition/keys [subject competition-name page-id]}
           (:properties component)

           process-atom (cmn/process-cursor app-atom)
           page-id (or page-id (cmn/curact process-atom [:dlp-page :id]))

           {:keys [firstname lastname email promotion-subscribe newsletter-subscribe answers]}
           (cmn/curact process-atom :competition)

           body
           (cond->
             {:firstname firstname
              :lastname lastname
              :email email
              :competition competition-name
              :pageid page-id
              :captcha-token (:captcha-token component)
              :sourceoverride (str/capitalize (:name component))
              :subjectemail subject
              :answers answers}
             (u/presence promotion-subscribe)
             (assoc :promotionsubscribe "1")
             (u/presence newsletter-subscribe)
             (assoc :newslettersubscribe "1")
             (u/presence (:rid params))
             (assoc :refid (:rid params)))]

       (swap! process-atom assoc :competition-component component)

       (comms/ajax-call :post :web.competition/submit body app-atom
         {:manual-error-handler? true}))))

(defn post-competition-form-legacy [app-atom component]
  #?(:cljs
     (let [params (cmn/screen-params app-atom)
           data (js/FormData.)
           {:competition/keys
            [subject competition-name page-id thank-you-title thank-you-text]}
           (:properties component)

           process-atom (cmn/process-cursor app-atom)
           page-id (or page-id (cmn/curact process-atom [:dlp-page :id]))

           {:keys [firstname lastname email promotion-subscribe newsletter-subscribe answers]}
           (cmn/curact process-atom :competition)]

       (.append data "SPA" true)
       (.append data "sname" "")
       (.append data "subjectemail" subject)
       (.append data "competition" competition-name)
       (.append data "sourceoverride" (str/capitalize (:name component)))
       (.append data "pageid" page-id)
       (.append data "firstname" firstname)
       (.append data "lastname" lastname)
       (.append data "email" email)
       (.append data "skip_redirect" true)
       (doseq [[answer-num answer-val] answers]
         (cond
           (map? answer-val)
           (doseq [[k v] answer-val]
             (.append data (str (name k)) v))

           :else
           (.append data answer-num answer-val)))
       (when (u/presence promotion-subscribe)
         (.append data "promotionsubscribe" "1"))
       (when (u/presence newsletter-subscribe)
         (.append data "newslettersubscribe" "1"))
       (when (u/presence (:rid params))
         (.append data "refid" (:rid params)))

       (ajax/POST
         "/forms.php?id=12&overrideincludes=ajax"
         {:body data
          :response-format :json
          :keywords? true
          :handler
          (fn [res]
            (cond
              (and (:existing_id res) (not (:success res)))
              (urlstate/redirect app-atom "competition-success" "" {:rid (:existing_id res)})

              (:success res)
              (if (or thank-you-title thank-you-text)
                (urlstate/redirect app-atom (cmn/page-base-url app-atom) "" {:stage "thankyou" :rid (:response_id res)})
                (urlstate/redirect app-atom "competition-success" "" {:rid (:response_id res)}))

              :else
              (do
                (toaster/close-toast app-atom)
                (grid/open-modal app-atom :web.competition/submit-error
                  {:config
                   {:message "Something went wrong."}}))))
          :error-handler
          (fn [res]
            (toaster/close-toast app-atom)
            (grid/open-modal app-atom :web.competition/submit-error
              {:config
               {:message "Something went wrong."}}))
          :timeout 60000}))))

(defn post-competition-form [app-atom component]
  #?(:cljs
     ;; Rollout flag: served by web.start config from the competition/clj-submit
     ;; feature flag. Off -> legacy PHP forms.php submission.
     (if (:competition-clj-submit? (cmn/curact app-atom :config))
       (post-competition-form-clj app-atom component)
       (post-competition-form-legacy app-atom component))))

(rum/defc error < rum/reactive [app-atom config-atom]
  (let [config (cmn/curact config-atom :config)
        message (:message config)]
    [:div.yc-popup.yc-popup--has-footer
     [:div.yc-popup__content
      (cond
        (not-empty message)
        [:p message]

        :else
        [:p "We didn't manage to enter you into the competition. Please try again, or "
         [:a (urlstate/href-props app-atom "contact") "contact us"]
         " for help."])]]))

(defmethod grid/modal-config :web.competition/submit-error [_ _ _]
  {:body-raw error
   :modal-type :alert})

(rum/defc competition-radio < rum/reactive
  [app-atom {:keys [description heading options question-name]}]
  (let [process-atom (cmn/process-cursor app-atom)
        competition-atom (rum/cursor process-atom :competition)]
    [:div.form-section.u-max-width-480.u-block-center
     (cond
       description
       [:p
        {:class (u/bem :form-question [:set])}
        description]

       heading
       [:label.ie-group.form-field
        {:class (u/bem :form-label [:set])}
        heading])

     (map-indexed
       (fn [idx option]
         [:div.form-field
          (forms/radio option option
            (rum/cursor-in competition-atom [:answers question-name])
            {:name question-name
             :id (str question-name "-" (str/replace option #" " "-") "_" idx)})])
       (str/split options #", "))]))

(rum/defc competition-checkbox < rum/reactive
  [app-atom
   {:keys [description heading options question-name required]}]
  (let [process-atom (cmn/process-cursor app-atom)
        competition-atom (rum/cursor process-atom :competition)]
    [:div.form-section.u-max-width-480.u-block-center
     (cond
       description
       [:p
        {:class (u/bem :form-question [:set])}
        description]

       heading
       [:label
        {:class (u/bem :form-label [:set])}
        heading])

     (map-indexed
       (fn [idx option]
         [:div.form-field
          (forms/checkbox option
            (rum/cursor-in competition-atom [:answers question-name (keyword option)])
            {:name (str question-name "-" option)
             :id (str question-name "-" option "_" idx)})])
       (str/split options #", "))]))

(rum/defc competition-dropdown < rum/reactive
  [app-atom
   {:keys [description heading options question-num required example question-name]}]
  (let [process-atom (cmn/process-cursor app-atom)
        competition-atom (rum/cursor process-atom :competition)]
    [:div.form-field.u-max-width-480.u-block-center
     (if description
       [:p.form-question description]
       [:label.form-label
        {:for question-name}
        (str heading ":")])

     (forms/select ""
       (rum/cursor-in competition-atom [:answers question-name])
       (concat [{:text "– Select –" :value ""}]
         (map
           (fn [option]
             {:text option
              :value option})
           (str/split options #", ")))
       {:hint example
        :required? (when (u/presence required) true)})]))

(rum/defc competition-textarea < rum/reactive
  [app-atom
   {:keys [description heading question-num required example question-name]}]
  (let [process-atom (cmn/process-cursor app-atom)
        competition-atom (rum/cursor process-atom :competition)]
    [:div.form-field.u-max-width-480.u-block-center
     (when description
       [:p {:class :form-question} description])

     (forms/textarea (if description "" (str heading ":"))
       (rum/cursor-in competition-atom [:answers question-name])
       {:hint (u/presence example)
        :id question-name
        :name question-name
        :required? (when (u/presence required) true)})]))

(rum/defc competition-images < rum/reactive
  [app-atom
   {:keys [description heading question-num required example question-name images]}]
  (let [process-atom (cmn/process-cursor app-atom)
        competition-atom (rum/cursor process-atom :competition)]
    [:div.form-section
     [:div.u-max-width-480.u-block-center
      [:p.form-question.u-text-center
       (or description heading)]
      [:span.u-text-center
       {:class (u/bem :form-label [:set])}
       (or example "Make your choice by clicking one of the images below")]]

     [:div.flex-grid-group
      (map
        (fn [[k img]]
          (let [{:keys [public_id]} img
                key-str (name k)]
            [:div
             {:class (u/bem :flex-grid-block [:s-1-2 :ml-1-3])}
             [:label.visual-option
              {:for (str "q_" question-num "_image_" question-name "_" key-str)}
              [:input.visual-option__radio
               {:type "radio"
                :name question-name
                :id (str "q_" question-num "_image_" question-name "_" key-str)
                :value (:name img)
                :required (when (u/presence required) true)
                :on-change
                #(swap! competition-atom
                   assoc-in [:answers question-name]
                   (:name img))}]
              [:figure.visual-option__content
               (web-common/lazy-image app-atom
                 public_id
                 {:class (u/bem :yc-simple-image [:full])}
                 {:w 318
                  :mw 318
                  :q "auto"
                  :alt (u/presence (:description img))})
               (when (u/presence (:description img))
                 [:figcaption.visual-option__caption
                  (:description img)])
               [:span.visual-option__icon
                [:i {:class (u/bem :icon [:check :default :block :is-dark])}]]]]]))
        images)]]))

(rum/defcs competition-form < rum/reactive cmn/cursors (cmn/local nil ::node-atom)
  [local-atom app-atom component]
  (let [node-atom (::node-atom local-atom)
        process-atom (cmn/process-cursor app-atom)
        competition-atom (rum/cursor process-atom :competition)
        {:keys [captcha-site-key]} (cmn/curact app-atom :config)
        {:competition/keys
         [submit-text hide-default-questions? newsletter-checkbox-title newsletter-checkbox-description
          hide-personalised-offers? newsletter-checked? newsletter-subscribed? questions]} (:properties component)

        newsletter-atom (rum/cursor competition-atom :newsletter-subscribe)
        promotion-atom (rum/cursor competition-atom :promotion-subscribe)

        _
        (when-not newsletter-subscribed?
          (when (nil? @newsletter-atom)
            (reset! newsletter-atom (boolean newsletter-checked?)))
          (when (nil? @promotion-atom)
            (reset! promotion-atom (not hide-personalised-offers?))))

        newsletter-on? (rum/react newsletter-atom)]

    [:form.yc-comp-form.form.u-block-center
     {:ref (fn [node] (reset! node-atom node))}
     (when-not hide-default-questions?
       [:<>
        [:div.u-max-width-480.u-block-center
         (forms/split-input-field
           ["First name:" "e.g. Jane"
            (rum/cursor competition-atom :firstname)
            {:type :user
             :id :firstname
             :name :firstname
             :required? true}]
           ["Last name:" "e.g. Smith"
            (rum/cursor competition-atom :lastname)
            {:type :user
             :id :lastname
             :name :lastname
             :required? true}])
         (forms/input "Email address:" "e.g. jane.smith@domain.com"
           (rum/cursor competition-atom :email)
           {:type :email
            :id :email
            :name :email
            :required? true
            :icon? true})]])
     [:<>
      (map
        (fn [[question-num {:keys [options required heading description example images] :as question}]]
          (when (and (:name question) heading)
            (cond
              (= (:type question) "radios")
              (competition-radio app-atom
                {:description description
                 :heading heading
                 :options options
                 :question-num question-num
                 :question-name (:name question)})

              (= (:type question) "checkboxes")
              (competition-checkbox app-atom
                {:description description
                 :heading heading
                 :options options
                 :question-num question-num
                 :question-name (:name question)
                 :required required})

              (= (:type question) "dropdown")
              (competition-dropdown app-atom
                {:description description
                 :heading heading
                 :options options
                 :question-num question-num
                 :required required
                 :example example
                 :question-name (:name question)})

              (= (:type question) "textarea")
              (competition-textarea app-atom
                {:description description
                 :heading heading
                 :question-num question-num
                 :required required
                 :example example
                 :question-name (:name question)})

              (= (:type question) "images")
              (competition-images app-atom
                {:description description
                 :heading heading
                 :question-num question-num
                 :required required
                 :example example
                 :question-name (:name question)
                 :images images})

              :else
              [:div.form-field.u-max-width-480.u-block-center
               (cond
                 description
                 [:p.form-question description]

                 :else
                 [:label.form-label
                  {:for (:name question)
                   :dangerouslySetInnerHTML
                   {:__html (str heading ":")}}])

               (cond
                 (= (:name question) "email")
                 (forms/input "" ""
                   (rum/cursor-in competition-atom [:answers (:name question)])
                   {:type :email
                    :id (:name question)
                    :name (:name question)
                    :icon true
                    :hint (u/presence example)
                    :required? (when (u/presence required) true)})

                 (= (:name question) "name")
                 (forms/input "" ""
                   (rum/cursor-in competition-atom [:answers (:name question)])
                   {:type :name
                    :id (:name question)
                    :name (:name question)
                    :icon true
                    :hint (u/presence example)
                    :required? (when (u/presence required) true)})

                 :else
                 (forms/input "" ""
                   (rum/cursor-in competition-atom [:answers (:name question)])
                   {:type :text
                    :id (:name question)
                    :name (:name question)
                    :hint (u/presence example)
                    :required? (when (u/presence required) true)}))])))
        (into (sorted-map) questions))]

     (when-not newsletter-subscribed?
       [:<>
        [:div.form-field.u-max-width-480.u-block-center
         (forms/toggle
           (or newsletter-checkbox-title "Sign up for the Yuppiechef newsletter.")
           newsletter-atom
           (cond->
             {:id :newsletter-subscribe
              :name :newsletter-subscribe
              :default-checked (boolean newsletter-checked?)
              :form-field? true
              :description
              (or
                newsletter-checkbox-description
                "We won't share your details with anyone and you can unsubscribe, if you like.")}
             (not hide-personalised-offers?)
             (assoc :on-change
               (fn [_]
                 (let [new-val (not @newsletter-atom)]
                   (reset! newsletter-atom new-val)
                   (when new-val
                     (reset! promotion-atom true)))))))]

        (when-not hide-personalised-offers?
          [:div.form-field.u-max-width-480.u-block-center
           (forms/toggle "Personalised offers only"
             promotion-atom
             {:id :promotion-subscribe
              :name :promotion-subscribe
              :default-checked true
              :disabled newsletter-on?
              :form-field? true
              :description "Sign up for the chance of occasional personalised vouchers, without getting our newsletters."})])])

     [:div.controls.u-max-width-480.u-block-center
      (buttons/button-web (or submit-text "Enter")
        (merge
          (urlstate/href-on-click
            (forms/form-validate node-atom
              #(appcommon/recaptcha app-atom captcha-site-key :web.competition/post-form component)))
          {:type :button
           :style :cta}))]]))

(defmethod grid/action :web.competition/post-form [app-atom config _]
  (toaster/open-toast app-atom :processing "Submitting form" {:closetime 5000})
  (post-competition-form app-atom config))

(defmethod comms/receive :web.competition/submit [app-atom res]
  (let [process-atom (cmn/process-cursor app-atom)
        component (cmn/curact process-atom :competition-component)
        {:competition/keys [thank-you-title thank-you-text]}
        (:properties component)]
    (toaster/close-toast app-atom)
    (cond
      (and (:existing_id res) (not (:success res)))
      (urlstate/redirect app-atom "competition-success" "" {:rid (:existing_id res)})

      (:success res)
      (if (or thank-you-title thank-you-text)
        (urlstate/redirect app-atom (cmn/page-base-url app-atom) ""
          {:stage "thankyou" :rid (:response_id res)})
        (urlstate/redirect app-atom "competition-success" ""
          {:rid (:response_id res)}))

      :else
      (grid/open-modal app-atom :web.competition/submit-error
        {:config
         {:message
          (or
            (u/presence (:error_message res))
            (u/presence (:msg res))
            "Something went wrong.")}}))))

(rum/defc thank-you-screen < rum/reactive [app-atom component]
  (let [{:competition/keys
         [social-sharing? social-sharing-text social-sharing-link
          hashtag thank-you-text meta-title title banners facebook-api-id]}
        (:properties component)]
    [:<>
     [:div
      {:class
       (u/bem :yc-section
         [(if (and thank-you-text social-sharing?) :medium :large)])}
      (when thank-you-text
        [:div.yc-intro-text
         {:dangerouslySetInnerHTML
          {:__html thank-you-text}}])]

     (when (and social-sharing-link social-sharing-text)
       [:div
        {:class (u/bem :yc-section [:large])}
        (headings/heading "Get extra entries by sharing this competition"
          {:type :h2
           :size :small
           :center true})
        [:div.u-block-center.u-max-width-640
         [:p.yc-paragraph.u-text-center
          "For each friend that enters using your unique link below, you'll get another entry and increase your chances to win the grand prize."]]

        [:div.flex-grid-group
         [:div
          {:class (u/bem :flex-grid-block [:s-1-2 :m-1-3 :ml-1-4])}
          [:div.flex-grid-content
           (buttons/button-web
             (list
               [:span.clip-text.unclip-text--t.clip-text--m.unclip-text--l
                "Send on "]
               "Whatsapp")
             {:href (str "https://api.whatsapp.com/send?text=" social-sharing-text social-sharing-link (url/url-encode "&utm_source=WhatsApp&utm_medium=share"))
              :style :cta
              :size :default
              :full true
              :icon :whatsapp})]]

         [:div
          {:class (u/bem :flex-grid-block [:s-1-2 :m-1-3 :ml-1-4])}
          [:div.flex-grid-content
           (buttons/button-web
             (list
               [:span.clip-date.unclip-date--t.clip-date--m.unclip-date--l
                "Share on "]
               "Facebook")
             {:href
              (str
                "https://www.facebook.com/dialog/feed?app_id=" facebook-api-id
                "&display=popup" (when social-sharing-text (str "&quote=" social-sharing-text))
                "&link=" (url/url-encode (str social-sharing-link "&utm_source=Facebook&utm_medium=share"))
                "&redirect_uri=" (url/url-encode "http://www.yuppiechef.com/popup-close.htm"))
              :style :facebook
              :size :default
              :full true
              :icon :facebook})]]
         [:div
          {:class (u/bem :flex-grid-block [:s-1-2 :m-1-3 :ml-1-4])}
          [:div.flex-grid-content
           (buttons/button-web
             (list
               [:span.clip-date.unclip-date--t.clip-date--m.unclip-date--l
                "Share on "]
               "X")
             {:href
              (str
                "http://twitter.com/share?"
                (when (or social-sharing-text hashtag)
                  (str "text="
                    (when hashtag
                      (url/url-encode (str hashtag " ")))
                    social-sharing-text "&"))
                "url=" (url/url-encode (str social-sharing-link "&utm_source=Twitter&utm_medium=share")))
              :style :twitter
              :size :default
              :full true
              :icon :twitter})]]
         [:div
          {:class (u/bem :flex-grid-block [:s-1-2 :m-1-3 :ml-1-4])}
          [:div.flex-grid-content
           (buttons/button-web
             (list
               [:span.clip-date.unclip-date--t.clip-date--m.unclip-date--l
                "Share by "]
               "email")
             {:href
              (str
                "mailto:%20?subject="
                (cond
                  meta-title
                  meta-title

                  :else
                  (->
                    title
                    (str/strip-tags)
                    (str/replace #"/ +/" " ")
                    (str/trim)
                    (str/capitalize)))
                "&body=" social-sharing-text
                social-sharing-link "&utm_source=Email&utm_medium=share")
              :style :secondary
              :size :default
              :full true
              :icon :email})]]]])

     (banner/hero app-atom {:section-size "large" :banners banners})]))

(rum/defc competition < rum/reactive [app-atom _ component]
  (let [{:competition/keys
         [hide-header-banner? title title-pretext title-subtitle
          responsive-banner-public-id logo-picture-public-id logo-custom-size
          image-width main-text banner-background-colour form-title
          terms-and-conditions-title sidebar-picture-public-id
          terms-and-conditions-text thank-you-title closed? thank-you?
          closed-title closed-text expired?]}
        (:properties component)
        {:banner-background-colour/keys [colour-name text-dark]} banner-background-colour

        prize-image-width
        (case image-width
          "default" 320
          "small" 480
          "medium" 640
          "large" 720
          image-width)

        comp-closed? (or closed? expired?)

        title-heading
        (cond
          comp-closed?
          (or closed-title title)

          thank-you?
          (or thank-you-title title)

          :else
          title)

        banner-title-heading
        (str
          (when title-pretext
            (str "<span class='header-banner__pretext'>" title-pretext "</span><span class='u-hidden-from-view'> - </span>"))
          title
          (when title-subtitle
            (str "<span class='u-hidden-from-view'> - </span><span class='header-banner__subtitle'>" title-subtitle "</span>")))]

    [:<>
     (when-not hide-header-banner?
       [:div
        {:class
         (u/bem :header-banner
           [(when-not responsive-banner-public-id :no-image)]
           (when colour-name (str "u-bg-" colour-name)))}
        [:div.header-banner__text-wrapper
         (when logo-custom-size
           [:div
            {:dangerouslySetInnerHTML
             {:__html (hd/add-styles (u/parseInt logo-custom-size))}}])

         (cond
           logo-picture-public-id
           (web-common/lazy-image app-atom
             logo-picture-public-id
             {:class ["header-banner__logo" (when logo-custom-size "header-banner__logo--custom")]}
             {:q "auto"
              :alt (str title " logo")})

           title-heading
           [:div.header-banner__text
            {:class (if (not text-dark) "u-text-white" "u-text-oil")}
            [:h1.header-banner__title
             {:dangerouslySetInnerHTML
              {:__html banner-title-heading}}]])]

        (when responsive-banner-public-id
          [:div.header-banner__image-wrapper
           (web-common/lazy-image app-atom
             responsive-banner-public-id
             {:class ["header-banner__image"]}
             {:w 960
              :mw 490
              :q "auto"
              :alt (str "Banner image of " title)})])])

     (when (and (u/presence title-heading) (or hide-header-banner? logo-picture-public-id comp-closed? thank-you?))
       (headings/heading
         title-heading
         {:type :h2
          :center true
          :size :large
          :pretext (when-not (or comp-closed? thank-you?) title-pretext)
          :subtext (when-not (or comp-closed? thank-you?) title-subtitle)
          :dangerouslySetInnerHTML? true}))

     [:div
      {:class (when hide-header-banner? (u/bem :yc-page-content [:medium]))}
      (cond
        comp-closed?
        [:div
         {:class (u/bem :yc-section [:large])}
         [:div.yc-intro-text
          {:dangerouslySetInnerHTML
           {:__html (or closed-text "")}}]]

        thank-you?
        (thank-you-screen app-atom component)

        :else
        [:<>
         [:div
          {:class (u/bem :yc-section [:standard-underline])}
          [:div.yc-intro-text
           (when sidebar-picture-public-id
             [:div
              {:class (u/bem :yc-comp-prize [:center] (str "u-max-width-" prize-image-width))}
              (web-common/lazy-image app-atom
                sidebar-picture-public-id
                {:class ["yc-comp-prize__image"]}
                {:w prize-image-width
                 :mw 480
                 :q "auto"
                 :alt ""})])
           [:span
            {:dangerouslySetInnerHTML
             {:__html (or main-text "")}}]]]
         [:div
          {:class (u/bem :yc-section [:large])}
          (when (u/presence form-title)
            (headings/heading form-title
              {:type :h2
               :size :medium
               :center true
               :dangerouslySetInnerHTML? true}))
          (competition-form app-atom component)

          (when (u/presence terms-and-conditions-text)
            [:aside.yc-comp-terms.u-max-width-480
             (headings/heading
               (or terms-and-conditions-title "Terms & Conditions")
               {:type :h3
                :size :tiny})
             [:span
              {:dangerouslySetInnerHTML
               {:__html terms-and-conditions-text}}]])]])]]))
